import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import { call, spawn, put, select } from 'redux-saga/effects'
import { runSaga } from 'store/sagaMiddleware'
import { KanBoJsonApi } from 'api/Api'
import { AuthError } from '@kanbo/api'
import taskStatus from './taskStatus'
import {
  remove as removeToast
} from 'store/redux/toasts'
import sweetalert from 'sweetalert2'

export default function * requestAddBoard (action) {
  const { template, name, background, isTemplate, boardInstallerPlugin: { identifier, args } = {}, onSuccess, onFail, methodArgs = {}} = action.payload

  try {
    const { Id, Name, Background, IsObserved, IsClosed, IsTemplate, TaskId } = yield call(KanBoJsonApi.action, 'AddBoard', {
      template,
      name: name.trim(),
      background,
      isTemplate,
      identifier,
      args,
      ...methodArgs
    })

    if (TaskId) {
      yield spawn(taskStatus, {
        taskId: TaskId,
        progressMessage: (
          <FormattedMessage
            id={isTemplate ? 'BOARD_TEMPLATE_ADD_PROGRESS_RUNNING' : 'BOARD_ADD_PROGRESS_RUNNING'}
            values={{
              name: <b>{name.trim()}</b>
            }}
          />
        ),
        completedMessage: (
          <FormattedMessage
            id={isTemplate ? 'BOARD_TEMPLATE_ADD_PROGRESS_COMPLETED' : 'BOARD_ADD_PROGRESS_COMPLETED'}
            values={{
              name: (
                <Link
                  to={`/board/${Id}`}
                  onClick={() => runSaga(function * () {
                    yield put(removeToast({
                      id: `task-${TaskId}`,
                    }))
                  })}
                >
                  {name.trim()}
                </Link>
              )
            }}
          />
        ),
        failMessage: (
          <FormattedMessage
            id={isTemplate ? 'BOARD_TEMPLATE_ADD_PROGRESS_FAILED' : 'BOARD_ADD_PROGRESS_FAILED'}
            values={{
              name: <b>{name.trim()}</b>
            }}
          />
        ),
      })
    }

    if (onSuccess) {
      onSuccess({
        id: Id,
        name: Name,
        background: Background,
        isObserved: IsObserved,
        hasAccess: true,
        isClosed: IsClosed,
        isTemplate: IsTemplate,
      })
    }
  } catch (error) {
    if (onFail) {
      onFail()
    }

    if (error instanceof AuthError) {
      const state = yield select()

      try {
        yield call(sweetalert, {
          text: state.kanbo.locale.messages['DOCUMENTS_SOURCE_ACCESS_DENIED_ACTION_ERROR'],
          type: 'info'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}
